import BaseBtModal from "../../BaseBtModal.vue";
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "LimitModal",
  components: {
    BaseBtModal,
    BaseAlert,
    BaseButton
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object,
      required: true
    }
  },
  emits: ["open-signin-modal", "closed", "opened"],
  methods: {
    openSignInModal() {
      this.$emit("open-signin-modal");
    },
    onClosed() {
      this.$emit("closed");
    },
    onOpened() {
      this.$emit("opened");
    }
  }
});